import Highlight from "./highlight";
import {ActionTypeEnum} from "../../base/training-literals";

class UserActionMoveObjects extends Highlight {

    constructor(props = {}) {
        super(props);
        this.actionType = props.actionType || ActionTypeEnum.USER_ACTION_MOVE_OBJECTS;
    }

    isActiveOperation(operationName) {
        if (operationName.includes(ActionTypeEnum.HIGHLIGHT) && this.selectionObjectType !== null
            && operationName.includes(this.selectionObjectType)) {
            return true;
        }
        return false;
    }
}

export default UserActionMoveObjects;
